import { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';
import { useTranslation } from 'react-i18next';

import useAdSetup from 'lib/hooks/useAdSetup';
import { Zone, PageType, AgeType } from 'lib/CarGurusAds/TaxonomySchema';
import CarGurusAdUnit from 'lib/CarGurusAds/AdUnit';
import isIndexable from 'lib/isIndexable';

import Layout from 'components/Layout';
import AboutUs from 'components/AboutUs';

interface PageProps {
  indexable: boolean;
}

export default function AboutUsPage({ indexable }: PageProps): JSX.Element {
  const carGurusAdUnit = new CarGurusAdUnit({ zone: Zone.Research });
  const { t } = useTranslation();
  useAdSetup(carGurusAdUnit.toString(), {
    make: null,
    model: null,
    year: null,
    pageType: PageType.AboutUs,
    ageType: AgeType.None,
    cpo: false,
    inLine: 1,
    body_style: null,
    category: null,
    app: 'web',
    sellerId: null,
  });

  return (
    <Layout
      description={t(`main.meta.pageTitle`)}
      title={t(`main.meta.pageTitle`)}
      indexed={indexable}
    >
      <AboutUs />
    </Layout>
  );
}

export async function getServerSideProps({
  req,
}: GetServerSidePropsContext): Promise<GetServerSidePropsResult<PageProps>> {
  const indexable = isIndexable(req);
  return { props: { indexable } };
}
